module.exports = __webpack_public_path__ + "assets/img/68@3x.c9b3b9e5.png";